/* eslint-disable */
import { createSelector } from 'reselect';
import ordersAddressesSelector from './OrderAddress.selector';

/**
 * Select the order address list
 * @returns {OrderAddressEntity | null} The `order` address list that has been selected from the store
 */
const ordersAddressesListSelector = createSelector(ordersAddressesSelector, (addresses = {}) => addresses.list || {});

export default ordersAddressesListSelector;
